import React from 'react';
import { planBadge } from '../utils/planDisplay';

// Tone -> classes. A plain map rather than CgBadge: CgBadge hard-codes
// `bg-primaryColor` and white text (CgBadge.jsx:14), so every status would render
// the same brand green — which is the one thing this badge exists not to do.
const TONES = {
  grey: 'bg-slate-100 text-slate-600 ring-slate-200',
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  amber: 'bg-amber-50 text-amber-800 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
};

export default function PlanStatusBadge({ plan, now }) {
  const { tone, label } = planBadge(plan, now);
  return (
    <span
      data-testid="plan-status-badge"
      data-tone={tone}
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${TONES[tone]}`}
    >
      {label}
    </span>
  );
}
